import React from 'react';
import { Phone, MessageCircle, ChevronDown } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-[90vh] flex items-center bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Content */}
          <div className="order-2 lg:order-1 space-y-8">
            <div className="space-y-4">
              <p className="text-[#722F37] text-sm font-medium tracking-widest uppercase animate-fade-in-up">
                {restaurantInfo.slogan}
              </p>
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#333333] leading-tight animate-fade-in-up stagger-1">
                Gerçek Lezzetin<br />
                <span className="text-[#722F37]">Güvencesi</span>
              </h1>
              <p className="text-[#666666] text-lg md:text-xl max-w-lg leading-relaxed animate-fade-in-up stagger-2">
                {restaurantInfo.description}
              </p>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-6 animate-fade-in-up stagger-3">
              <div className="flex items-center gap-2 text-[#333333]">
                <div className="w-10 h-10 rounded-full bg-[#722F37]/10 flex items-center justify-center">
                  <span className="text-[#722F37] font-bold text-sm">%100</span>
                </div>
                <span className="text-sm font-medium">Helal Kesim</span>
              </div>
              <div className="flex items-center gap-2 text-[#333333]">
                <div className="w-10 h-10 rounded-full bg-[#722F37]/10 flex items-center justify-center">
                  <span className="text-[#722F37] font-bold text-xs">TSE</span>
                </div>
                <span className="text-sm font-medium">TSE Onaylı</span>
              </div>
              <div className="flex items-center gap-2 text-[#333333]">
                <div className="w-10 h-10 rounded-full bg-[#722F37]/10 flex items-center justify-center">
                  <span className="text-[#722F37] font-bold text-sm">35</span>
                </div>
                <span className="text-sm font-medium">Yıllık Tecrübe</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up stagger-4">
              <a
                href={`https://wa.me/${restaurantInfo.whatsapp}?text=Merhaba, sipariş vermek istiyorum.`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-4 text-base font-semibold hover:bg-[#128C7E] transition-all duration-200"
              >
                <MessageCircle size={20} />
                WhatsApp ile Sipariş
              </a>
              <a
                href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
                className="inline-flex items-center justify-center gap-3 bg-transparent border border-[#722F37] text-[#722F37] px-8 py-4 text-base font-semibold hover:bg-[#722F37] hover:text-white transition-all duration-200"
              >
                <Phone size={20} />
                Hemen Ara
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="order-1 lg:order-2 relative animate-fade-in">
            <div className="relative">
              <img
                src={restaurantInfo.heroImage}
                alt="Kosovalı Döner"
                className="w-full h-[400px] lg:h-[550px] object-cover"
              />
              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-[#722F37] text-white p-6 hidden md:block">
                <p className="font-display text-3xl font-bold">1990</p>
                <p className="text-sm opacity-90">yılından beri</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
        <button
          onClick={() => document.querySelector('#menu').scrollIntoView({ behavior: 'smooth' })}
          className="text-[#722F37] opacity-60 hover:opacity-100 transition-opacity"
          aria-label="Aşağı kaydır"
        >
          <ChevronDown size={32} />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;